import { quickQueryCards } from "../types/chat-bot-hub/QuickQueryCards";
import { recordingNetworkUsers } from "../types/chat-bot-hub/recordingNetworkUsers";
import { UserChatDetails } from "../types/chat-bot-hub/UserChatDetails";
import { axiosWithAuth } from "../utils/customAxios";

const chatBotService = {
    getChatsById: async (): Promise<UserChatDetails[]> => {
      try{
        const response = await axiosWithAuth.get(`CopilotActivity`);
        const chatDetails: UserChatDetails[] = response.data;
        return chatDetails;
        }
      catch (err) {
          console.log(err);
          throw err;
            }
      },
      getChatHistoryBySessionId:async (id: Number): Promise<UserChatDetails> => {
        try{
          const response = await axiosWithAuth.get(`CopilotActivity/${id}`);
          const chatDetails: UserChatDetails = response.data;
          return chatDetails;
          }
          catch (err) {
          console.log(err);
          throw err;
            }
      },
      getQuickQueryCards: async (): Promise<quickQueryCards[]> => {
        try{
        const response = await axiosWithAuth.get(`CopilotActivity/quickQueryCards`);
        const quickQueryCards: quickQueryCards[] = response.data;
        return quickQueryCards;
        }
        catch (err) {
        console.log(err);
        throw err;
            }
      },
      deleteChat:async (id: Number) => {
        try
        {
        const response = await axiosWithAuth.delete(`CopilotActivity/${id}`);
        return response.data;
        }
        catch (err) {
        console.log(err);
        throw err;
            }
      },
      fetchTotalRecordedUsers:async (): Promise<recordingNetworkUsers> =>{
         try{
        const response = await axiosWithAuth.get(`CopilotActivity/recordingNetworkLicensedUsers`);
        const recordingNetworkUsers: recordingNetworkUsers = response.data;
        return recordingNetworkUsers;
        }
      catch (err) {
          console.log(err);
          throw err;
            }
      }
}
export default chatBotService;